
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/motorcycle-trips",
      function () {
        return require("private-next-pages/motorcycle-trips.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/motorcycle-trips"])
      });
    }
  